var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"perfil"},[_c('footer',{staticClass:"perfil__bar"},[_c('desktop-footer',{staticClass:"perfil__bar__desktop-footer"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }